import axios from "axios";

export const state = {
    schoolrequirements: [],
};

export const getters = {
    schoolrequirements: state => state.schoolrequirements,
};

export const mutations = {
        setSchoolRequirement(state, newValue) {
        state.schoolrequirements = newValue
    },
};

export const actions = {
    fetchSchoolRequirement({ commit }) {
        axios.get('/schoolrequirements').then(res => {
            commit('setSchoolRequirement', res.data.carts);

        })
    },
};
